/**
 * @deprecated, always go for immutable version!
 */
export function removeNestedObjectsMutate(object: any, keyName: string, keyValue: string): void {
  if (Array.isArray(object)) {
    object.forEach((item, index) => {
      if (typeof item === 'object') {
        removeNestedObjectsMutate(item, keyName, keyValue);
        if (item.hasOwnProperty(keyName) && item[keyName] === keyValue) {
          object.splice(index, 1);
        }
      }
    });
  } else if (typeof object === 'object') {
    for (const key of Object.keys(object)) {
      removeNestedObjectsMutate(object[key], keyName, keyValue);
      if (object[key].hasOwnProperty(keyName) && object[key][keyName] === keyValue) {
        delete object[key];
      }
    }
  }
}

export function removeNestedObjectsImmutable(object: any, keyName: string, keyValue: any): any {
  if (Array.isArray(object)) {
    return object
      .map((item) => removeNestedObjectsImmutable(item, keyName, keyValue))
      .filter((item) => {
        if (typeof item === 'object') {
          return !(item.hasOwnProperty(keyName) && item[keyName] === keyValue);
        }

        return true;
      });
  } else if (typeof object === 'object') {
    let newObject = { ...object };
    for (const key of Object.keys(newObject)) {
      newObject[key] = removeNestedObjectsImmutable(newObject[key], keyName, keyValue);
      if (newObject[key].hasOwnProperty(keyName) && newObject[key][keyName] === keyValue) {
        delete newObject[key];
      }
    }

    return newObject;
  }

  return object;
}
